import React, { useState } from "react";
import { Button, Label } from "semantic-ui-react";
import { Bars, Filters } from "ceicons";
import Search from "../Search";

import "./Header.scss";

export default function Header(props) {
  const {
    title,
    menuExpanded,
    setMenuExpanded,
    sidebarExpanded,
    setSidebarExpanded,
    sidebarActiveCount,
    sidebarIcon: SidebarIcon = Filters,
    searchText,
    onSearchTextChange,
    children,
  } = props;
  const [isOpenSearch, setIsOpenSearch] = useState(false);

  return (
    <div className="header">
      <div className="header__title">
        {setMenuExpanded && (
          <Bars onClick={() => setMenuExpanded(!menuExpanded)} />
        )}
        {title && !isOpenSearch && <h1>{title}</h1>}
      </div>
      <div className="header__right">
        <div className="header-right">
          {onSearchTextChange && (
            <Search
              isOpenSearch={isOpenSearch}
              setIsOpenSearch={setIsOpenSearch}
              searchText={searchText}
              onSearchTextChange={onSearchTextChange}
            />
          )}
          {children}
          {setSidebarExpanded && (
            <div className="header-right__action">
              <Button
                size="massive"
                onClick={() => setSidebarExpanded(!sidebarExpanded)}
                icon={<SidebarIcon />}
              />
              {sidebarActiveCount !== undefined && (
                <Label floating circular>
                  {sidebarActiveCount}
                </Label>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
